<template>
  <div class="modal-impressao-titulo">
    <h2>
      Impressão
    </h2>
    <div class="modal-impressao-fecha" @click="handleModalClose">
      <font-awesome-icon icon="times" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalImpressaoTitulo",
  props: {
    handleModalClose: Function
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
.modal-impressao-fecha {
  width: 20px;
  height: 20px;
  cursor: pointer;
  user-select: none;
  display: flex;
  justify-content: center;
  align-content: center;
  font-size: 20px;
  position: absolute;
  right: 5px;
}
.modal-impressao-titulo {
  height: 30px;
  background: $corImpressao;
  text-transform: uppercase;
  color: var(--branco);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 5px 5px 10px;
  position: relative;
  h2 {
    line-height: 30px;
    height: 30px;
    padding-top: 1px;
    margin: 0;
    font-size: 15px;
    font-family: "Roboto Condensed";
  }
}
</style>
